import React from 'react';
import PropTypes from 'prop-types';

const RadioInputButton = props => {
  const {name, value, label, id, checked, readOnly, disabled} = props;
  return (
    <label htmlFor={id}>
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        readOnly={readOnly}
        disabled={disabled}
      />
      {label}
      </label>
  );
};

RadioInputButton.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  checked: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool
};

export default RadioInputButton;
